<script lang="ts">
    import SortableTable from "$lib/components/SortableTable.svelte";
    import {onMount} from "svelte";
    import Select from "$lib/components/ui/Select.svelte";
    import NumberInput from "$lib/components/ui/NumberInput.svelte";
    import dayjs from "dayjs";
    import RemoveButton from "$lib/components/ui/RemoveButton.svelte";
    import TimeInput from "$lib/components/ui/TimeInput.svelte";
    import {availableQualifications} from "$lib/calls/qualification";

    export let project;

    let days = [];

    let header: Array<SortableTableHeaderElement> = [

        {
            label: 'Anzahl',
            property: 'amount',
            component: NumberInput,
            class: 'w-1/6',
            movable: false
        },
        {
            label: 'Qualifikation',
            property: 'qualificationId',
            component: Select,

            props: {options: []},
            movable: false
        },
        {
            label: 'Von',
            property: 'startsAt',
            component: TimeInput,
            movable: false
        },
        {
            label: 'Bis',
            property: 'endsAt',
            component: TimeInput,
            movable: false
        }
    ]
    onMount(() => {
        if(typeof project.workEntries === 'undefined' || project.workEntries.length < 1){
            project.workEntries = [{
                amount: 1
            }]
        }
        const start = dayjs(project.startsAt)
        const diff = dayjs(project.endsAt).diff(start, 'day')
        if(diff > 0){
            for(let i =0; i<=diff;i++){
                const current = start.add(i, 'day')
                days.push({
                    value: current.format('YYYY-MM-DD'),
                    label: current.format('DD.MM.YYYY')
                })
            }

            header = [...header, {
                label: 'Tag',
                property: 'day',
                component: Select,
                class: 'w-1/4',
                props: {
                    options: days
                }
            }]
        }
        header = [...header, {
            label: 'Entfernen',
            property: 'index',
            component: RemoveButton,
            props: {
                onClick: index => {
                    project.workEntries = project.workEntries.filter((x,ind) => ind !== index)
                },
                classes: 'text-center pt-1'
            },
            class: 'w-8'
        }]

        availableQualifications().then(res => {
            header[header.findIndex(x => x.property === 'qualificationId')].props.options = res.map(x => {
                return {
                    value: x.id,
                    label: x.title
                }
            })
        })

    })
    function addRow(){
        project.workEntries = [...project.workEntries, {amount: 1}]
    }
</script>
<h3 class="text-2xl  leading-7 text-neutral-600 mb-3 mt-4">Erforderliches Personal</h3>
<SortableTable bind:data={project.workEntries} {header} />
<div class="mt-5 grid justify-center">
    <button on:click={addRow} type="button" class="rounded-full border p-1 text-coolGray-500 hover:text-white shadow-sm hover:bg-coolGray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coolGray-600">
        <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
        </svg>
    </button>
</div>
